import React, { useState } from "react";
import "./PortalUserCreation.scss";
import { NewPortaluser, PictureNew, MerchantPiAdd } from "../../util/API/customers";
import CustomForm from "../UI/CustomForm/CustomForm";
import { formatDate } from "../../util/utilfunctions/utilFunctions";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import { Box } from "@mui/material";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";

function PortalUserCreation({ open, handleClose, roles, updateUser, setUpdateUser, portalUsers }) {
  const [userData, setUserData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    birthDate: "",
    role: "",
    areaCode: "",
    city: "",
    country: "",
    zip: "",
    address: "",
    areaCodeCountry: "",
  });
  const [alert, setAlert] = useState({
    showAlert: false,
    message: '',
    severity: '',
    header: ''
  });

  const [userImage, setUserImage] = useState("");
  const [userBase64, setUserBase64] = useState("");
  const [errors, setError] = useState("");
  const [newUser, setNewUser] = useState("");

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      let reader = new FileReader();

      reader.onload = (e) => {
        setUserImage(e.target.result);
        setUserBase64(e.target.result);
      };

      reader.readAsDataURL(img);
    }
  };

  const securityRoles = [
    { role: "Admin", roleId: 828 },
    { role: "Associate", roleId: 829 },
    { role: "Partner", roleId: 830 },
    { role: "Finance", roleId: 831 },
    { role: "Audit", roleId: 832 },
    { role: "Compliance", roleId: 833 },
    { role: "Analyst", roleId: 834 },
    { role: "Agent", roleId: 835 },
    { role: "System", roleId: 836 },
  ];

  const handleCloseModal = () => {
    handleClose();
    setNewUser("");
    setError("");
  };

  const handleSubmit = async (data, formData) => {
    setNewUser("");
    setError("");

    const requiredFields = formData
        .filter((field) => field.validation?.required)
        .map((field) => field.name);

    const missingFields = requiredFields.filter(
        (fieldName) => !data[fieldName] || data[fieldName].toString().trim() === ""
    );

    if (missingFields.length > 0) {
      return;        
    }

    let phoneNo = data.areaCode.value + data.phoneno;

    let requestData = { ...data }; // shallow copy

    if (requestData?.dob) {
      requestData.dob = formatDate(requestData.dob);
    }

    if (requestData?.phoneno) {
      requestData.phoneno = phoneNo;
    }

    let extendedFields = {};
    formData.forEach((item) => {
      if (item.core === 0 && requestData.hasOwnProperty(item.name)) {
        extendedFields[item.name] = requestData[item.name];
        delete requestData[item.name];
      }
    });

    requestData.extendedFields = JSON.stringify(extendedFields);

    try {
      const response = await NewPortaluser(requestData);
      console.log(response);

      let callStatus = response.data.Status;

      console.log(response.data.payload.msg)

      if (callStatus === "3") {

        let userId = response?.data?.payload?.userid;

        const response1 = await MerchantPiAdd(userId, 229, 2);
        const response2 = await MerchantPiAdd(userId, 230, 2);
        const response3 = await MerchantPiAdd(userId, 313, 42);

        if (callStatus === "3") {
          setNewUser("User created successfully");
          setAlert({
            showAlert: true,
            message: "Thank You! Admin User has been created successfully!",
            severity: "success",
            header: "Success"
          });
        }

        else {
          setAlert({
            showAlert: true,
            message: response?.data?.payload?.msg,
            severity: "error",
            header: "Error"
          });
        }

        setUpdateUser(!updateUser)

        setUserData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          birthDate: "",
          areaCode: "",
          city: "",
          country: "",
          zip: "",
          address: "",
          role: "",
        });

        if (userBase64) {
          await PictureNew(userId, userBase64);
        }
      } else {
        setError(`${response.data.msg}`);
        setAlert({
          showAlert: true,
          message: `${response?.data?.payload?.msg}`,
          severity: "error",
          header: "Error"
        });
      }
    } catch (error) {
      console.error(error);
      setError("An error occurred while creating the user.");
    }
  };

  return (
    // <Box>
      <BaseDrawer 
        open={open} 
        handleClose={handleCloseModal} 
        height="90vh"
        title={"New Portal User"}
      >
        <Box className="portal-creation-container">
          <Box className="newrole-container">
            <Box className="customer-photos">
            </Box>
            <Box className="admin-details">
              <CustomForm
                formName={"newagent"}
                fieldRendererType={"registration"}
                onSubmit={handleSubmit}
                buttonText={"Add User"}
                loadingButtonText={"Adding User..."}
                twoColumns={true}
                buttonInPanel={true}
                roles={roles}
                isRegistration={true}
              />
            </Box>
          </Box>
        </Box>
        <CustomAlert
          severity={alert.severity}
          show={alert.showAlert}
          header={alert.header}
          message={alert.message}
          onClick={() => {
            setAlert({ ...alert, showAlert: false }); 
            if (alert.severity === "success") {
              handleCloseModal();
            }
          }}
          autoclose={alert.severity === "error" ? false : true}
        />
      </BaseDrawer>
  );
}

export default PortalUserCreation;
